import React, { useEffect, useState } from "react";
import Card from "src/components/Cards/Basic";
import { Form, Formik } from "formik";
import { Button, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axios from "../../../../../config/axios";
import { showSuccessToast } from "../../../../../components/Toasts";
import FormInputText from "../../../../../components/Forms/FormInputText";
import FormCheckbox from "src/components/Forms/FormCheckbox";
import StripeInfoModal from "../StripeInfoModal";
import FormSelectBox from "src/components/Forms/FormSelectBox";

const OnlineReservationsSettingsPage = () => {
  function submit(data, { setSubmitting, setErrors, resetForm }) {
    setSubmitting(true);
    setLoading(true);
    axios
      .put("api/v1/online_reservation_setting.json", {
        online_reservation_setting: data,
      })
      .then((response) => {
        setOnlineReservationSetting(response.data);
        showSuccessToast();
      })
      .catch(function (e) {
        setErrors(e.response.data);
      })
      .finally(() => {
        setSubmitting(false);
        setLoading(false);
      });
  }

  const [onlineReservationSetting, setOnlineReservationSetting] = useState({});
  const [showStripeDialog, setShowStripeDialog] = useState(false);

  const [loading, setLoading] = useState(true);
  const { t } = useTranslation("dashboard");

  useEffect(() => {
    setLoading(true);
    axios
      .get("api/v1/online_reservation_setting.json")
      .then(({ data }) => {
        setOnlineReservationSetting(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  let bank_transfer_hide_options = [
    {
      name: "Immer anzeigen",
      value: null,
    },
    {
      name: "1 Woche vorher ausblenden",
      value: 7,
    },
    {
      name: "2 Wochen vorher ausblenden",
      value: 14,
    },
    {
      name: "3 Wochen vorher ausblenden",
      value: 21,
    },
  ];

  return (
    <Card title={t("settings.online_reservation.title")}>
      {loading ? (
        <Spinner className={"d-block mx-auto"} animation="border" />
      ) : (
        <>
          <Formik
            initialValues={{
              deposit_percentage: onlineReservationSetting?.deposit_percentage,
              early_redemption_allowed:
                onlineReservationSetting?.early_redemption_allowed ?? false,
              stripe_enabled: onlineReservationSetting?.stripe_enabled ?? false,
              bank_transfer_enabled:
                onlineReservationSetting?.bank_transfer_enabled ?? false,
              bank_transfer_hide_if_arrival_within_days:
                onlineReservationSetting.bank_transfer_hide_if_arrival_within_days,
            }}
            enableReinitialize={true}
            onSubmit={submit}
          >
            {({ values, isSubmitting }) => (
              <Form autoComplete="off">
                <FormInputText
                  required
                  type={"number"}
                  name={"deposit_percentage"}
                  label={t(
                    "settings.online_reservation.deposit_percentage.label"
                  )}
                  hint={t(
                    "settings.online_reservation.deposit_percentage.hint"
                  )}
                />

                <FormCheckbox
                  name={"early_redemption_allowed"}
                  label={t(
                    "settings.online_reservation.early_redemption_allowed.label"
                  )}
                  hint={t(
                    "settings.online_reservation.early_redemption_allowed.hint"
                  )}
                />

                <h3>{t("settings.online_reservation.paymentMethods")}</h3>

                <div className={"d-flex align-items-center"}>
                  <FormCheckbox
                    className={"mr-2"}
                    label={t("settings.online_reservation.stripe.title")}
                    name={"stripe_enabled"}
                    hint={t("settings.online_reservation.stripe.hint")}
                  />
                  {values.stripe_enabled && (
                    <Button
                      className={"ml-2"}
                      size={"sm"}
                      variant={"secondary"}
                      onClick={() => {
                        setShowStripeDialog(true);
                      }}
                    >
                      {t("settings.online_reservation.stripe.details")}
                    </Button>
                  )}
                </div>

                <StripeInfoModal
                  show={showStripeDialog}
                  handleClose={() => setShowStripeDialog(false)}
                />
                <FormCheckbox
                  label={t("settings.online_reservation.bank_transfer.label")}
                  name={"bank_transfer_enabled"}
                />

                {values.bank_transfer_enabled && (
                  <FormSelectBox
                    label={t(
                      "settings.online_reservation.bank_transfer_hide_if_arrival_within_days.label"
                    )}
                    hint={t(
                      "settings.online_reservation.bank_transfer_hide_if_arrival_within_days.hint"
                    )}
                    name="bank_transfer_hide_if_arrival_within_days"
                    options={bank_transfer_hide_options}
                    required
                  />
                )}

                <Button type={"submit"} disabled={isSubmitting}>
                  <div className={"d-flex align-items-center"}>
                    {t("common:components.button.save")}
                  </div>
                </Button>
              </Form>
            )}
          </Formik>
        </>
      )}
    </Card>
  );
};

export default OnlineReservationsSettingsPage;
